// A quoi sert ce hook sachant qu'on fait la même chose dans le nuxtServerInit du store client ?

export default defineNuxtRouteMiddleware((route) => {

  if (process.server && route.query.h) {
    const res = useRequestEvent().node.res;
    res.cookie("service_prive", route.query.h);
  }

  return;
});
